import React, { useState, useEffect } from "react";
import { getAuth } from "firebase/auth";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import { app } from "./firebase";
import Swal from "sweetalert2";
import Card from "components/card";
import "./features.css";

const db = getFirestore(app);

const Features = () => {
  const [features, setFeatures] = useState({
    rawList: false,
    primaryEmail: false,
    secondaryEmail: false,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadAdminFeatures();
  }, []);

  const loadAdminFeatures = async () => {
    try {
      const auth = getAuth();
      const adminUid = auth.currentUser?.uid;

      if (!adminUid) {
        setLoading(false);
        return;
      }

      // Load each feature individually
      const rawListRef = doc(db, "users", adminUid, "features", "rawList");
      const primaryEmailRef = doc(db, "users", adminUid, "features", "primaryEmail");
      const secondaryEmailRef = doc(db, "users", adminUid, "features", "secondaryEmail");

      const [rawListSnap, primaryEmailSnap, secondaryEmailSnap] = await Promise.all([
        getDoc(rawListRef),
        getDoc(primaryEmailRef),
        getDoc(secondaryEmailRef),
      ]);

      setFeatures({
        rawList: rawListSnap.exists() ? rawListSnap.data().enabled : false,
        primaryEmail: primaryEmailSnap.exists() ? primaryEmailSnap.data().enabled : false,
        secondaryEmail: secondaryEmailSnap.exists() ? secondaryEmailSnap.data().enabled : false,
      });

      setLoading(false);
    } catch (error) {
      console.error("Error loading features:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to load features",
      });
      setLoading(false);
    }
  };

  const featuresList = [
    {
      key: "rawList",
      label: "Combined List Optimized",
      description: "Combined list optimization feature",
    },
    {
      key: "primaryEmail",
      label: "Email Optimization - Primary",
      description: "Primary email optimization feature",
    },
    {
      key: "secondaryEmail",
      label: "Email Optimization - Secondary",
      description: "Secondary email optimization feature",
    },
  ];

  if (loading) {
    return (
      <div className="mt-5">
        <Card extra="w-full pb-10 p-4 h-full">
          <h5>Loading features...</h5>
        </Card>
      </div>
    );
  }

  return (
    <div className="mt-5">
      <Card extra="w-full pb-10 p-4 h-full">
        <header className="mb-6">
          <h5>Features</h5>
          <p className="text-gray-500 mt-2">
            Available features for your admin account
          </p>
        </header>

        <div className="features-list">
          {featuresList.map((feature) => (
            <div key={feature.key} className="feature-item mb-4 p-4 border rounded">
              <div className="feature-info">
                <h6 className="mb-1">{feature.label}</h6>
                <p className="text-muted text-sm mb-0">{feature.description}</p>
                <div className="mt-2">
                  <span className={`badge ${features[feature.key] ? "bg-success" : "bg-secondary"}`}>
                    {features[feature.key] ? "✓ Enabled" : "✗ Disabled"}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>

     
      </Card>
    </div>
  );
};

export default Features;
